// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__lLsPq","footer":"styles_footer__V1RHp"};